import { ROUTES } from "common/constants/routes";
import RootLayout from "layouts/RootLayout";
import CompanyDetails from "pages/compony-details";
import Login from "pages/login";
import Signup from "pages/signup";
import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Signup />} />
      <Route path="company-details" element={<CompanyDetails />} />
      <Route path="/" element={<RootLayout />}>
        {ROUTES.map(
          ({ path, element, bannedFor, children }) =>
            !bannedFor &&
            (children ? (
              children.map((r) => <Route {...{ key: r?.path, path: r.path, element: r.element }} />)
            ) : (
              <Route key={path} {...{ path, element }} />
            ))
        )}
      </Route>
    </>
  )
);
const App = () => {
  return (
    <>
      <RouterProvider {...{ router }} />
      <ToastContainer />
    </>
  );
};

export default App;
